<template>
  <div class="container">
    <div class="week-box">
      <div
        @click="select(wkItem)"
        class="week-item"
        v-for="(wkItem, index) in wkList"
        :key="index"
      >
        <div class="select-box">
          <div
            :class="
              wkItem.time == selectWk ? 'wk-item-day-active' : 'wk-item-day'
            "
          >
            {{ wkItem.day }}
          </div>
        </div>
        <div class="wk-item-text">{{ wkItem.wknum }}</div>
        <div
          :class="
            checkTopStatus(wkItem)
              ? 'wk-item-text color-red'
              : 'wk-item-text color-blue'
          "
        >
          {{ checkTopStatus(wkItem) ? '无号' : '有号' }}
        </div>
      </div>
    </div>
    <div class="doctor-list">
      <div class="doctor-item" v-if="list">
        <div class="doctor-box">
          <div class="card-item">
            <div class="head-box">
              <img src="@/assets/head.jpg" alt="头像" />
            </div>
            <div class="head-name-detail">
              <div class="detail-item">
                <span class="name">{{ list.doctorName }}</span>
                <div
                  class="status color-blue"
                  v-if="timeList.length != timeCheckData.length"
                >
                  有号
                </div>
                <div
                  class="status color-red"
                  v-if="timeList.length == timeCheckData.length"
                >
                  无号
                </div>
              </div>
              <div class="detail-item">挂号级别：{{ list.doctorTitle }}</div>
              <div class="detail-item">
                出诊科室：{{ list.outpatientSectionName }}
              </div>
            </div>
            <div class="fee">￥{{ list.visitFee }}</div>
          </div>
        </div>
      </div>
      <div class="select-title">预约时间</div>
      <div class="select-time-content">
        <!-- :class="
            checkTime(item) ? 'select-time-item disabled' : 'select-time-item'
          "
          v-for="(item, index) in timeList"
          :key="index"
          @click="goPayDetail(item)" -->
        <div class="select-time-item" @click="goPayDetail()">
          <div class="flex-left"><i class="iconfont icon-clock"></i> 全天</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findBySectionId, unallowedOrders } from '@/api/api'
export default {
  data() {
    return {
      selectWk: '',
      list: {},
      wkList: [],
      timeList: [],
      timeCheckData: [],
      timeCheckDataList: {}
    }
  },
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let data = {
        outpatientSectionCode: this.$route.query.deptCode,
        doctorCode: this.$route.query.docCode
      }
      unallowedOrders(data).then(result => {
        this.timeCheckDataList = result.data
        findBySectionId(data).then(res => {
          let days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
          for (let i in res.data) {
            let iDate = new Date(Number(i))
            let map = {
              day: iDate.getDate(),
              wknum: days[iDate.getDay()],
              list: res.data[i][0],
              time: i
            }
            this.wkList.push(map)
            if (this.$route.query.selectTime) {
              if (i == this.$route.query.selectTime) {
                this.select(map)
              }
            }
          }
          if (!this.$route.query.selectTime) {
            this.select(this.wkList[0])
          }
        })
      })
    },
    select(item) {
      this.selectWk = item.time
      this.list = item.list
      this.timeList = item.list.visitTimeArr
      this.selectCheck(item.time)
    },
    selectCheck(time) {
      if (this.timeCheckDataList[time]) {
        this.timeCheckData = this.timeCheckDataList[time]
      } else {
        this.timeCheckData = []
      }
    },
    goPayDetail() {
      let date = new Date()
      this.$router.push({
        name: 'payDetail',
        query: {
          selectTime: date.getHours() + ':' + date.getMinutes(),
          selectDate: this.selectWk,
          sectionId: this.list.outpatientSectionCode,
          sectionName: this.list.outpatientSectionName,
          doctorId: this.list.doctorCode,
          doctorName: this.list.doctorName,
          patientId: this.$route.query.patientId,
          patientName: this.$route.query.patientName,
          fee: this.list.visitFee,
          sectionDoctorId: this.list.sectionDoctorId
        }
      })
    },
    checkTime(time) {
      return this.timeCheckData.includes(time)
    },
    checkTopStatus(item) {
      let timeList = item.list.visitTimeArr
      let checkData = this.timeCheckDataList[item.time] || []
      return timeList.length == checkData.length
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.week-box {
  width: 100%;
  overflow-x: auto;
  height: 85px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
}
.week-item {
  width: 14vw;
  min-width: 14vw;
  font-size: 12px;
  text-align: center;
  .select-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .wk-item-day {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      width: 25px;
      border-radius: 12.5px;
      margin-top: 10px;
      &-active {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        width: 25px;
        border-radius: 12.5px;
        margin-top: 10px;
        background-color: #3478f7;
        color: #fff;
      }
    }
  }
  .wk-item-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
  }
  .color-blue {
    color: #3478f7;
  }
  .color-red {
    color: red;
  }
}
.doctor-list {
  height: calc(100vh - 85px);
  max-height: calc(100vh - 85px);
  width: 100vw;
  background: rgb(242, 248, 243);
  .doctor-item {
    width: 100%;
    height: 80px;
    background: #fff;
    box-shadow: 3px 0 9px #ebedf0;
    padding: 10px;
    font-size: 13px;
    margin-bottom: 10px;
    .doctor-box {
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-item {
        width: 100%;
        // height: 55px;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        .head-box {
          width: 40px;
          height: 40px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .head-name-detail {
          width: calc(100% - 100px);
          .detail-item {
            width: 100%;
            height: 22.5px;
            display: flex;
            align-items: flex-end;
            padding-left: 10px;
            color: #666;
            font-size: 12px;
            .name {
              font-size: 15px;
              padding-right: 10px;
              color: #000;
            }
            .status {
              padding: 2px 5px;
              color: #fff;
              border-radius: 3px;
              margin-left: 10px;
            }
            .color-blue {
              background: #3478f7;
            }
            .color-red {
              background: red;
            }
          }
        }
        .fee {
          width: 60px;
          font-size: 12px;
          color: #ed7d54;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    .doctor-num {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      justify-content: space-between;
      .bet {
        .much {
          font-size: 12px;
          color: rgb(237, 125, 84);
          padding-right: 5px;
        }
      }
    }
  }
}
.select-title {
  width: 100vw;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #fff;
  border-bottom: 1px solid rgb(240, 240, 240);
}
.select-time-content {
  width: 100vw;
  display: flex;
  flex-flow: wrap;
  background: #fff;
  max-height: calc(100% - 130px);
  overflow-y: auto;
  .select-time-item {
    width: calc(100% / 3);
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgb(240, 240, 240);
    border-bottom: 1px solid rgb(240, 240, 240);
    .flex-left {
      display: flex;
      justify-content: flex-start;
      width: 60px;
      i {
        margin-right: 5px;
      }
    }
  }
  .disabled {
    background: rgb(240, 240, 240);
    pointer-events: none;
  }
  .select-time-item:nth-child(3n) {
    border-right: 0;
  }
}

@font-face {
  font-family: 'iconfont';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-clock:before {
  content: '\e617';
}
</style>
